


































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as faceFilter from "facefilter/dist/jeelizFaceFilter.module";
import {
  JeelizFaceFilter,
  JeelizFaceFilterDetectState,
  JeelizFaceFilterInitResult,
} from "face-filter";
import { HeadTracker, Phase, TurnDirection } from "@/utils/headtracker";
import * as RecordRTC from "recordrtc/RecordRTC";
import * as FaceUtils from "@/utils/canvas2ddisplay";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";
import { namespace } from "vuex-class";
import axios, { AxiosResponse } from "axios";

import Loader from "@/components/svg/Loader.vue";
import ErrorSvg from "@/components/svg/Error.vue";
import { FetchDirectionPayload } from "../types";

function rad2deg(radians: number) {
  return radians * (180 / Math.PI);
}
const Theme = namespace("theme");
const Selfie = namespace("selfie");

let turnHeadPLay = false;

@Component({
  metaInfo() {
    return {
      title: "Orba One | Take Your Selfie",
    };
  },
  components: {
    loader: Loader,
    error: ErrorSvg,
    "previous-page-arrow": PreviousPageArrow,
  },
})
export default class CaptureSelfie extends Vue {
  @Theme.Getter("getAccentColor") primaryColor;
  @Selfie.Action("fetchTurnDirection") fetchTurnDirection!: (
    payload: FetchDirectionPayload
  ) => Promise<AxiosResponse>;
  @Selfie.Getter("getTurnDirection") direction;

  isValidationError = false;
  errorMessage = "";

  isUploading = false;
  isUploadingError = false;
  isCameraLoading = true;
  hasError = false;
  recorder: any = null;
  filter: JeelizFaceFilter = faceFilter;
  blob: Blob = new Blob();
  innerCanvas?: HTMLCanvasElement;
  isRecording = false;
  textStyles = {
    fontSize: "20px Arial",
    color: "rgba(0, 0, 0,0.9)",
    align: "center",
  };

  // Add this method to test the camera stream directly:

  async testCameraStream(deviceId: string) {
    try {
      const constraints: MediaStreamConstraints = {
        video: deviceId
          ? { deviceId: { exact: deviceId }, width: 800, height: 600 }
          : { facingMode: "user", width: 800, height: 600 },
        audio: false,
      };

      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      console.log("Camera stream obtained successfully:", stream);
      console.log("Video tracks:", stream.getVideoTracks());

      // Test if we can see the video
      const testVideo = document.createElement("video");
      testVideo.srcObject = stream;
      testVideo.play();

      return stream;
    } catch (error) {
      console.error("Error getting camera stream:", error);
      return null;
    }
  }

  async getContinuityCameraStream() {
    try {
      // Request permissions first
      await navigator.mediaDevices.getUserMedia({ video: true });

      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(
        (device) => device.kind === "videoinput"
      );

      console.log(
        "Available cameras:",
        videoDevices.map((d) => ({
          id: d.deviceId,
          label: d.label,
        }))
      );

      const iphoneCamera = videoDevices.find(
        (device) =>
          device.label.toLowerCase().includes("iphone") ||
          device.label.toLowerCase().includes("continuity")
      );

      if (iphoneCamera) {
        console.log("Found iPhone/Continuity Camera:", iphoneCamera.label);
        return iphoneCamera.deviceId;
      }

      if (videoDevices.length > 1) {
        console.log(
          "Using last camera:",
          videoDevices[videoDevices.length - 1].label
        );
        return videoDevices[videoDevices.length - 1].deviceId;
      }

      return null;
    } catch (error) {
      console.error("Error enumerating devices:", error);
      return null;
    }
  }

  async mounted() {
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.stopPrepareForSelfie();
    }

    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const tracker = new HeadTracker();

    if (publicKey && applicantId) {
      await this.fetchTurnDirection({
        applicantId,
        publicKey,
      });
      tracker.setTurnDirection(
        this.direction === "left" ? TurnDirection.Left : TurnDirection.Right
      );
    }

    const cameraDeviceId = await this.getContinuityCameraStream();

    // Test the camera stream before initializing Jeeliz
    if (cameraDeviceId) {
      const testStream = await this.testCameraStream(cameraDeviceId);
      if (!testStream) {
        console.error("Failed to get camera stream, falling back to default");
      }
    }

    let CVD: any = null;

    const canvas = document.querySelector(
      "#jeeFaceFilterCanvas"
    ) as HTMLCanvasElement;
    this.innerCanvas = document.createElement("canvas");
    this.innerCanvas.width = canvas.width;
    this.innerCanvas.height = canvas.height;

    // Try different approaches based on Jeeliz version
    const initConfig: any = {
      canvasId: "jeeFaceFilterCanvas",
      NNCpath: "/js/",
      callbackReady: (errorCode, spec: JeelizFaceFilterInitResult) => {
        console.log("Jeeliz callback ready - errorCode:", errorCode);
        console.log("Jeeliz spec:", spec);

        if (errorCode) {
          console.error("Jeeliz initialization error:", errorCode);
          this.hasError = true;
          this.isCameraLoading = false;
          return;
        }

        const { canvasElement: jeelizCanvasElement } = spec;
        console.log("Canvas element:", jeelizCanvasElement);

        this.recorder = new RecordRTC(jeelizCanvasElement, {
          type: "canvas",
          disableLogs: true,
          mimeType: "video/mp4",
        });

        CVD = FaceUtils.Canvas2DDisplay(spec);
        console.log("CVD initialized:", CVD);

        tracker.start();
        this.isCameraLoading = false;
      },
      callbackTrack: async (detectState: JeelizFaceFilterDetectState) => {
        const { detected: detectedThreshold, ry: headRotationY } = detectState;
        const recorder = this.recorder;

        if (detectedThreshold >= 0.8) {
          if (this.innerCanvas) {
            const innerCtx = this.innerCanvas.getContext("2d");
            if (innerCtx) {
              innerCtx.drawImage(CVD.canvas, 0, 0);
            }
          }
          await this.drawOverlay(CVD.canvas, CVD.ctx, tracker);
          CVD.update_canvasTexture();
          tracker.update(rad2deg(headRotationY));
        } else {
          if (
            !tracker.isComplete() &&
            tracker.phase !== Phase.ReturnToCenter &&
            tracker.phase !== Phase.TurnHead
          ) {
            tracker.start();
            recorder.stopRecording();
            this.isRecording = false;
          }
        }

        if (tracker.phase == Phase.TurnHead && !this.isRecording) {
          this.isRecording = true;
          recorder.startRecording();
        }

        if (tracker.isComplete()) {
          if (recorder != null) {
            setTimeout(() => {
              recorder.stopRecording(() => {
                faceFilter.destroy();
                this.blob = recorder.getBlob();
                if (!this.blob) return;
                this.uploadSelfie();
              });
            }, 200);
          }
        }

        CVD.draw();
      },
    };

    // Option 1: Try with videoSettings (if Jeeliz supports it)
    if (cameraDeviceId) {
      initConfig.videoSettings = {
        deviceId: { exact: cameraDeviceId },
        width: { ideal: 800 },
        height: { ideal: 600 },
      };
    }

    // Option 2: Try with direct constraints (alternative property name)
    if (cameraDeviceId && !initConfig.videoSettings) {
      initConfig.constraints = {
        video: {
          deviceId: { exact: cameraDeviceId },
          width: { ideal: 800 },
          height: { ideal: 600 },
        },
      };
    }

    console.log("Initializing Jeeliz with config:", initConfig);

    try {
      faceFilter.init(initConfig);
    } catch (error) {
      console.error("Error initializing Jeeliz:", error);
      this.hasError = true;
      this.isCameraLoading = false;
    }
  }

  uploadSelfie() {
    //this.isUploadingError = true;
    this.isValidationError = false;
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");

    if (publicKey && applicantId) {
      const formData = new FormData();
      formData.append("file", this.blob, "video.webm");
      formData.append("applicantId", applicantId);
      formData.append("publicKey", publicKey);

      this.isUploading = true;

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/selfiedata/uploadvideo_new`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(() => {
          const safeQuery = Object.fromEntries(
            Object.entries(this.$route.query).filter(
              ([_, v]) => v !== undefined
            )
          );
          this.isUploading = false;
          this.isUploadingError = false;

          const params = new URLSearchParams(window.location.search);
          const publicKey = params.get("publicKey");
          const applicantId = params.get("applicantId");
          const magicLink = params.get("magic");
          const progressionStep = 4;

          if ((publicKey && applicantId) || magicLink) {
            axios.put(
              `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
              {
                publicKey,
                progressionStep,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
          }

          this.$router.push({
            name: "chooseCountry",
            query: safeQuery,
          });
        })
        .catch((err) => {
          console.log(err);
          //     this.showErrorToast(
          //   "PDF files are not supported. Please upload an image instead."
          // );
          this.isUploading = false;
          this.isUploadingError = true;
          this.isValidationError = true;

          try {
            const errorResponse = err?.response?.data;
            const errorObj = Array.isArray(errorResponse?.errors)
              ? errorResponse.errors[0]
              : null;

            if (errorObj?.code === "applicant_already_processed") {
              this.showErrorToast("Applicant is already processed");
            } else if (errorObj?.message) {
              this.showErrorToast(errorObj.message);
            } else if (errorResponse?.message) {
              this.showErrorToast(errorResponse.message);
            } else {
              this.showErrorToast(
                "An unexpected error occurred while uploading."
              );
            }
          } catch (parseErr) {
            console.error("Error handling response:", parseErr);
            this.showErrorToast("Failed to read server error response.");
          }
        });
    }
  }

  showErrorToast(message: string) {
    this.isValidationError = true;

    // Optionally store a dynamic message
    (this as any).errorMessage = message;

    // Auto-hide after 4 seconds
    setTimeout(() => {
      this.isValidationError = false;
    }, 5000);
  }

  clickTos() {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const magicLink = params.get("magic");
    const progressionStep = 2;

    if ((publicKey && applicantId) || magicLink) {
      axios.put(
        `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
        {
          publicKey,
          progressionStep,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  }

  async drawOverlay(
    canvas: HTMLCanvasElement,
    ctx: CanvasRenderingContext2D,
    tracker: HeadTracker
  ): Promise<void> {
    const faceWidth = 0.35;
    const faceHeight = 0.45;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (tracker.phase == Phase.CenterHead) {
      ctx.fillStyle = "rgba(200, 200, 200,0.5)";
      ctx.beginPath();
      ctx.rect(0, 0, canvas.width, canvas.height);

      ctx.ellipse(
        canvas.width * 0.5,
        canvas.height * 0.5,
        canvas.width * faceWidth,
        canvas.width * faceHeight,
        0,
        0,
        2 * Math.PI,
        true
      );
      ctx.fill();

      // stroke
      ctx.strokeStyle = this.primaryColor;
      ctx.lineWidth = 4;
      ctx.beginPath();

      ctx.ellipse(
        canvas.width * 0.5,
        canvas.height * 0.5,
        canvas.width * faceWidth,
        canvas.width * faceHeight,
        0,
        2 * Math.PI * tracker.progress,
        2 * Math.PI,
        true
      );

      ctx.stroke();
    }

    if (tracker.phase == Phase.TurnHead) {
      ctx.fillStyle = "rgba(200, 200, 200,0.5)";
      ctx.beginPath();
      ctx.rect(0, 0, canvas.width, canvas.height);

      ctx.ellipse(
        canvas.width * 0.5,
        canvas.height * 0.5,
        canvas.width * faceWidth,
        canvas.width * faceHeight,
        0,
        0,
        2 * Math.PI,
        true
      );
      ctx.fill();

      // stroke
      ctx.strokeStyle = this.primaryColor;
      ctx.lineWidth = 4;
      ctx.beginPath();

      ctx.ellipse(
        canvas.width * 0.5,
        canvas.height * 0.5,
        canvas.width * faceWidth,
        canvas.width * faceHeight,
        0,
        0,
        2 * Math.PI,
        true
      );
      ctx.setLineDash([10, 10]);
      ctx.stroke();
      ctx.setLineDash([]);

      // stroke line to show progress
      const centerX = canvas.width * 0.5;
      const centerY = 520;
      const lineSpan = 50;
      ctx.lineWidth = 8;

      ctx.strokeStyle = "gray";
      ctx.beginPath();
      ctx.moveTo(centerX + lineSpan, centerY);
      ctx.lineTo(centerX - lineSpan, centerY);
      ctx.stroke();

      ctx.strokeStyle = "limegreen";
      ctx.beginPath();
      if (tracker.dir == TurnDirection.Left) {
        ctx.moveTo(centerX + lineSpan, centerY);
        ctx.lineTo(
          centerX + lineSpan - lineSpan * tracker.progress * 2,
          centerY
        );
      } else {
        ctx.moveTo(centerX - lineSpan, centerY);
        ctx.lineTo(
          centerX - lineSpan + lineSpan * tracker.progress * 2,
          centerY
        );
      }
      ctx.stroke();

      ctx.fillStyle = this.textStyles.color;
      ctx.font = "20px Arial";
      ctx.textAlign = "center";
      ctx.fillText(
        `Turn your head ${this.direction} then back`,
        canvas.width / 2,
        canvas.height - 50
      );

      if (Vue.prototype.$useAudioInstructions && !turnHeadPLay) {
        turnHeadPLay = true;
        await Vue.prototype.$audioConfigs.playTurnHead(this.direction);
      }
    }

    if (tracker.phase == Phase.ReturnToCenter) {
      ctx.fillStyle = "rgba(200, 200, 200,0.5)";
      ctx.beginPath();
      ctx.rect(0, 0, canvas.width, canvas.height);
      ctx.fill();

      ctx.strokeStyle = "black";
      ctx.lineWidth = 4;
      ctx.beginPath();

      ctx.ellipse(
        canvas.width * 0.5,
        canvas.height * 0.5,
        canvas.width * faceWidth,
        canvas.width * faceHeight,
        0,
        0,
        2 * Math.PI,
        true
      );
      ctx.setLineDash([10, 10]);
      ctx.stroke();
      ctx.setLineDash([]);

      ctx.fillStyle = this.textStyles.color;
      ctx.font = "20px Arial";
      ctx.textAlign = "center";
      ctx.fillText(
        `Turn your head ${this.direction} then back`,
        canvas.width / 2,
        550
      );
    }

    if (tracker.phase == Phase.Complete) {
      ctx.fillStyle = "rgba(200, 200, 200,0.5)";
      ctx.beginPath();
      ctx.rect(0, 0, canvas.width, canvas.height);
      ctx.fill();

      ctx.strokeStyle = "black";
      ctx.lineWidth = 4;
      ctx.beginPath();

      ctx.ellipse(
        canvas.width * 0.5,
        canvas.height * 0.5,
        canvas.width * faceWidth,
        canvas.width * faceHeight,
        0,
        0,
        2 * Math.PI,
        true
      );
      ctx.setLineDash([10, 10]);
      ctx.stroke();
      ctx.setLineDash([]);

      // instructions
      ctx.fillStyle = this.textStyles.color;
      ctx.font = "20px Arial";
      ctx.textAlign = "center";
      ctx.fillText("Complete", canvas.width / 2, 550);
    }
  }

  async destroyed() {
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.stopTurnHead();
    }
    if (faceFilter) {
      await faceFilter.destroy();
    }
    if (this.recorder) {
      this.recorder.stopRecording();
    }
  }
}
